import 'ngstorage';

export default 'ngStorage';
